import React, {useState} from 'react';
import {CustomTabProps} from './Tab';
import {CardContent, CardHeader, IconButton, SxProps, Typography} from '@mui/material';

import {createStyles, makeStyles} from '@mui/styles';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import Tooltip from '@mui/material/Tooltip';
import {Card} from '../../controls/Card/Card';
import {Theme} from '@mui/material/styles';

export interface CardProps {
    item: CustomTabProps;
    sx?: SxProps<Theme>
}

export const useStyles = makeStyles((theme) =>
    createStyles({
        main: {
            margin: theme.spacing(1),
            marginBottom: 18,
            borderTop: '2px solid ' + theme.palette.primary.main,
        },
        title: {
            display: 'initial',
            alignItems: 'center',
            fontSize: '22px',
        },
        cardHeader: {
            paddingBottom: theme.spacing(0),
            paddingTop: 0
        },
        cardContent: {
            paddingTop: 0,
        },
        subLabel: {
            fontSize: theme.typography.fontSize,
            display: 'inline-block',
            marginLeft: theme.spacing(2),
        },
    })
);

export const CardItem = React.memo(React.forwardRef<HTMLDivElement, CardProps>((props, ref) => {
    const {item, sx} = props;
    const [visibleLegacyFields, setVisibleLegacyFields] = useState(false);
    const classes = useStyles();

    const newProps = {
        visibleLegacyFields: visibleLegacyFields,
        setVisibleLegacyFields: setVisibleLegacyFields,
    };

    return (
        <Card
            className={classes.main}
            data-name={`section-${item.id}`}
            key={item?.id?.toString()}
            style={{
                scrollSnapAlign: 'start'
            }}
            sx={sx}
            ref={ref}
        >
            <CardHeader
                className={classes.cardHeader}
                hidden={props.item.hiddenHeader}
                action={
                    item.addHideFieldLegacy ? (
                        <Tooltip
                            title={!visibleLegacyFields ? 'Vis mer' : 'Vis mindre'}
                            placement="bottom"
                        >
                            <IconButton
                                aria-label="settings"
                                component={'span'}
                                onClick={() => setVisibleLegacyFields((prev) => !prev)}
                            >
                                <MenuOpenIcon color="primary"/>
                            </IconButton>
                        </Tooltip>
                    ) : (
                        <></>
                    )
                }
                title={
                    <Tooltip
                        title={item.tooltipTitle ? item.tooltipTitle : ''}
                        placement="bottom"
                    >
                        <Typography
                            style={{position: 'relative', marginRight: '20px'}}
                            gutterBottom
                            variant="h5"
                            component="div"
                            className={classes.title}
                        >
                            {item.label}{' '}
                            {item.subLabel && (
                                <small className={classes.subLabel}>{item.subLabel}</small>
                            )}
                        </Typography>
                    </Tooltip>
                }
            ></CardHeader>
            <CardContent className={classes.cardContent}>
                {item.tab && item.addHideFieldLegacy
                    ? React.cloneElement(item.tab, newProps)
                    : item.tab}
            </CardContent>
        </Card>
    );
}));
